import { render, staticRenderFns } from "./emailLogin.vue?vue&type=template&id=1b06cdc8&scoped=true&"
import script from "./emailLogin.vue?vue&type=script&lang=js&"
export * from "./emailLogin.vue?vue&type=script&lang=js&"
import style0 from "./emailLogin.vue?vue&type=style&index=0&id=1b06cdc8&prod&scoped=true&lang=less&"
import style1 from "./emailLogin.vue?vue&type=style&index=1&id=1b06cdc8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b06cdc8",
  null
  
)

export default component.exports